// extracted by css-extract-rspack-plugin
export default {"aiMarkdown":"Wmbhu"};